import React, { useEffect, useState } from "react";
import CustomDatatableGrid from "../../components/CustomDatatableGrid";
import { get } from "../../services/api";
import { Link, Navigate, NavLink, useNavigate } from "react-router-dom";
import profilePic from "../../assets/img/generic/logo.png";
import AddNewButton from "../../components/buttons/AddNewButton";
import { customTableStyles } from "../../assets/CustomTableStyles";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import logo from "../../assets/img/logo-full.png";

function OrganizationList() {
  const token = localStorage.getItem("token");

  const navigate = useNavigate();

  const [organizationsData, setOrganizationsData] = useState([]);

  const getOrganizationsList = async () => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await get("Organization/GetAllOranizationAsync", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setOrganizationsData(response);
      //localStorage.setItem("organizationId", "null");
    } catch (error) {
      console.error("Error fetching organizations:", error);
    }
  };

  useEffect(() => {
    getOrganizationsList();
  }, []);

  const columns = [
    {
      accessorKey: "mrt-row-numbers",
      header: "Sr No.",
      enableColumnOrdering: false,
      enableEditing: false, 
      enableSorting: false, 
      size: 80,
      Cell: ({ row }) => row.index + 1,
    },
    {
      accessorKey: "id",
      header: "ID",
      size: 70,
    },
    {
      accessorKey: "legalName",
      header: "Legal Name",
      Cell: ({ row }) => {
        let imageSrc = "";

        if (row.original.companyLogo === "" || row.original.companyLogo === "string") {
          imageSrc = `${process.env.PUBLIC_URL}/image/team/avatar-placeholder.jpg`;
        } else {
          imageSrc = `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages/${row.original.logoPath}`;
        }

        return (
          <div className="d-flex align-items-center gap-2">
            <div className="table-listing-image-preview">
              <img src={imageSrc} alt="Image" />
            </div>
            <div className="">{row.original.legalName}</div>
          </div>
        );
      },
    },
    {
      accessorKey: "registrationNumber",
      header: "Registration No",
    },
    {
      accessorKey: "countryName",
      header: "Country",
    },
    {
      accessorKey: "emailAddress",
      header: "Email",
    },
    {
      accessorKey: "phoneNumber",
      header: "Phone",
    },
  ];

  const handleRowClick = (row) => {
    localStorage.setItem("organizationId", row.id);
    navigate("/organization-form");
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(organizationsData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Organizations");
    XLSX.writeFile(workbook, "Organizations.xlsx");
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    // const logoWidth = 30;
    // const logoHeight = 8;
    // const logoX = (pageWidth - logoWidth) / 2;
    // const logoY = 10;
    // doc.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);

    const title = "Organization List";
    const titleFontSize = 12;
    doc.setFontSize(titleFontSize);
    doc.setFont("helvetica", "bold");
    const textWidth = doc.getTextWidth(title);
    const titleX = (pageWidth - textWidth) / 2;
    const titleY = 20;
    doc.text(title, titleX, titleY);

    const includedColumns = columns.filter(
      (column) => column.accessorKey !== "id" && column.accessorKey !== "mrt-row-numbers"
    );

    const headers = [["Sr No.", ...includedColumns.map((col) => col.header)]];

    const bodyData = organizationsData.map((row, index) => [
      index + 1,
      ...includedColumns.map((col) => row[col.accessorKey] || ""),
    ]);

    doc.autoTable({
      head: headers,
      body: bodyData,
      theme: "striped",
      startY: titleY + 10,
      headStyles: {
        fillColor: [132, 23, 26],
        textColor: [255, 255, 255],
        halign: "center",
      },
      styles: {
        overflow: "linebreak",
      },
    });

    doc.save("OrganizationList.pdf");
  };

  useEffect(() => {
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new window.bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, []);



  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Organizations</h2>
        <div className="ms-auto">
          <AddNewButton
            title="Add New"
            toUrl="/organization-form"
            localStorageItemsToBeNulled={["organizationId"]}
          />
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <CustomDatatableGrid
            columns={columns}
            data={organizationsData}
            onExportExcel={exportToExcel}
            onExportPDF={exportToPDF}
            initialState={{ columnVisibility: { id: false } }}
            muiTableBodyRowProps={({ row }) => ({
              onClick: () => handleRowClick(row.original),
              sx: { cursor: "pointer" },
            })}
          />
        </div>
      </div>
    </>
  );
}

export default OrganizationList;
